import React, { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import dayjs from 'dayjs';

const buttonSx = {
  borderRadius: '25px',
  textTransform: 'none',
  fontWeight: 600,
  px: 3,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(25,118,210,.4)'
  }
};

const FilterBar = ({ onChange }) => {
  const [custom, setCustom] = useState({ start: '', end: '' });

  const push = (payload) => onChange(payload);   // shorthand

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      gap={2}
      sx={{
        mt: 2,
        mb: 3,
        p: 3,
        backgroundColor: '#f8f9fa',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        justifyContent: 'center'
      }}
    >
      {/* Quick buttons */}
      <Button sx={buttonSx} variant="contained" onClick={() => push({ filterType: 'today'   })}>Today</Button>
      <Button sx={buttonSx} variant="contained" onClick={() => push({ filterType: 'yesterday'})}>Yesterday</Button>
      <Button sx={buttonSx} variant="contained" onClick={() => push({ filterType: 'last7'   })}>Last 7 Days</Button>
      <Button sx={buttonSx} variant="contained" onClick={() => push({ filterType: 'month'   })}>This Month</Button>

      {/* Custom range */}
      <TextField
        label="Start Date"
        type="date"
        size="small"
        InputLabelProps={{ shrink: true }}
        onChange={(e) => setCustom({ ...custom, start: e.target.value })}
      />
      <TextField
        label="End Date"
        type="date"
        size="small"
        InputLabelProps={{ shrink: true }}
        onChange={(e) => setCustom({ ...custom, end: e.target.value })}
      />
      <Button
        sx={buttonSx}
        variant="contained"
        onClick={() => {
          if (custom.start && custom.end) {
            push({ filterType: 'custom', ...custom });
          }
        }}
      >
        Apply
      </Button>

      {/* Reset */}
      <Button
        variant="outlined"
        color="secondary"
        sx={buttonSx}
        onClick={() => {
          setCustom({ start: '', end: '' });
          push({ filterType: 'none', start: '', end: '' });
        }}
      >
        Reset
      </Button>
    </Box>
  );
};

export default FilterBar;
